// eventBus.js
import mitt from 'mitt';
export const EventBus = mitt(); // Create an instance of mitt
